import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Helmet } from 'react-helmet-async';

export const PasswordDefined = () => {
    return (
        <Container>
            <Helmet title="Mot de passe defini" />
            <Title>Mot de passe defini avec succes</Title>
            <Message>Vous pouvez maintenant vous connecter via l'application.</Message>
            <BackLink to="/">Retour a la connexion</BackLink>
        </Container>
    );
};

const Container = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.backgroundColor};
`;

const Title = styled.h1`
    text-transform: uppercase;
    color: ${({ theme }) => theme.textColor};
    letter-spacing: 0.7px;
    font-size: 40px;
`;

const Message = styled.p`
    color: ${({ theme }) => theme.textColor};
    font-size: 16px;
    text-align: center;
    max-width: 400px;
`;

const BackLink = styled(Link)`
    color: ${({ theme }) => theme.ctaPrimaryTextColor};
    margin-top: 20px;
`;
